var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1468 11.781C28.0449 9.01702 31.9551 9.01703 32.8532 11.781L36.0619 21.6563C36.4635 22.8924 37.6154 23.7293 38.9151 23.7293H49.2987C52.2048 23.7293 53.4131 27.4481 51.062 29.1563L42.6615 35.2597C41.61 36.0236 41.1701 37.3777 41.5717 38.6138L44.7804 48.4892C45.6784 51.2531 42.515 53.5515 40.1639 51.8433L31.7634 45.7399C30.7119 44.976 29.2881 44.976 28.2366 45.7399L19.8361 51.8433C17.485 53.5515 14.3216 51.2531 15.2196 48.4892L18.4283 38.6138C18.8299 37.3777 18.39 36.0236 17.3385 35.2597L8.938 29.1563C6.58686 27.4481 7.79518 23.7293 10.7014 23.7293H21.085C22.3846 23.7293 23.5365 22.8924 23.9381 21.6563L27.1468 11.781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.11683b4ca75e1f6b0e42e1bd01f026d7.svg";
export { ForwardRef as ReactComponent };